<script setup lang="ts">
const { startGeolocationWatch } = useGPS();
const { $pwa } = useNuxtApp();

const { setInstallPrompt } = useInstallPrompt();

await startGeolocationWatch();

onMounted(async () => {
  setTimeout(async () => {
    await $pwa.install();
  }, 3000);

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    setInstallPrompt(e);
  });
});
</script>

<template>
  <div class="h-full">
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#57B39A 0%,#7cccb3 50%,#d6f1e7 100%)" />
    <NotificationContainer />
    <ModalContainer />
    <NuxtPwaManifest />
    <PwaInstallBanner />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
